<template>
    <div :class="classes">
        <template v-if="preparing">
            <Spinner class="spinner--preparing spinner--opaque">
                {{ stateTip }}
            </Spinner>
        </template>
        <template v-else>
            <slot v-if="canTrigger" name="trigger" :start="start" :open="open">
                <button
                    v-if="!opened"
                    v-tooltip="$t('booksBuilds.tips.trigger')"
                    class="books-builds__trigger"
                    @click.prevent="start"
                >
                    <IconDownload />
                </button>
            </slot>
        </template>
        <portal to="modals">
            <Modal
                v-if="opened"
                name="books-builds"
                modal-class="books-builds__modal"
                :title="$t('booksBuilds.title')"
                @close="close"
            >
                <template #content>
                    <form
                        v-if="schema && canSelectBuilder"
                        id="books-builds-form"
                        @submit.prevent="submit"
                    >
                        <Grid>
                            <Column :span="6">
                                <BuildersSelect
                                    v-model="selectedBuilder"
                                    :options="buildersList"
                                    :disabled="loading"
                                />
                            </Column>
                        </Grid>
                        <template v-if="builderFactory">
                            <BuilderWrapper :factory="builderFactory" :loading="loading" />
                        </template>
                    </form>
                </template>
                <template #bottom>
                    <button
                        v-if="canSelectBuilder"
                        v-t="'booksBuilds.edit.submitButton'"
                        form="books-builds-form"
                        type="submit"
                        :disabled="!canBuilding"
                        :class="[
                            'button',
                            'button--outlined',
                            {
                                'is-disabled': !canBuilding
                            }
                        ]"
                    />
                    <AccordionList v-if="permissions.builds" :initital-state="{ activeItem: 0 }">
                        <Spinner v-if="loading" />
                        <Accordion :item-id="0">
                            <template #head>
                                <div v-t="'booksBuilds.list.title'" class="accordion__title" />
                            </template>
                            <template #content>
                                <BuildsList :builds="bookBuilds" />
                            </template>
                        </Accordion>
                    </AccordionList>
                </template>
            </Modal>
        </portal>

        <Dialog
            v-model="dialogBrokenParts"
            title="booksBuilds.emptyParts.title"
            @close="transition({ type: 'CANCEL' })"
        >
            <template #default>
                <div v-text="$t('booksBuilds.emptyParts.description')" />
            </template>
            <template #actions="{ close }">
                <button
                    class="button button--outlined"
                    @click.prevent="$emit('openBrokenEditor')"
                    v-text="$t('booksBuilds.emptyParts.actions.correct')"
                />
                <button
                    class="button button--outlined"
                    @click.prevent="transition({ type: 'REPAIR' })"
                    v-text="$t('booksBuilds.emptyParts.actions.repair')"
                />
                <button
                    class="button button--outlined button--cancel"
                    @click.prevent="close"
                    v-text="$t('misc.cancel')"
                />
            </template>
        </Dialog>
    </div>
</template>
<script>
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import { Modal } from '@speechki-frontend/shared/ui/modals';
import { Accordion, AccordionList } from '@speechki-frontend/shared/ui/Accordion';
import { IconDownload } from '@speechki-frontend/shared/ui/icons';
import BuildersSelect from './BuildersSelect';
import BuilderWrapper from './BuilderWrapper';
import BuildsList from './BuildsList';
import Dialog from './Dialog';
import helper from './helper';

export default {
    name: 'BooksBuilds',
    components: {
        Accordion,
        AccordionList,
        Modal,
        IconDownload,
        Grid,
        Column,
        Spinner,
        BuildersSelect,
        BuilderWrapper,
        BuildsList,
        Dialog
    },
    mixins: [helper],
    data() {
        return {
            opened: false
        };
    },
    computed: {
        classes() {
            return [
                'books-builds',
                {
                    'books-builds--is-actual': this.isActualBuilds,
                    'books-builds--is-opened': this.opened
                }
            ];
        }
    },
    methods: {
        start(event) {
            try {
                this.transition({ type: 'START', event });
            } catch (err) {
                this.open(event);
            }
        },
        open(event) {
            this.opened = true;
            this.$emit('open', event);
        },
        close(event) {
            this.opened = false;
            this.$emit('close', event);
        }
    }
};
</script>

<style lang="scss" src="./BooksBuilds.scss"></style>
